import { useEffect, useState } from 'react';

import { IUseState } from '../../shared/types/IUseState';

export interface IUseScript {
    loaded: boolean;
}

export function useScript (url: string): IUseScript {
    const [loaded, setLoaded]: IUseState<boolean> = useState<boolean>(false);

    useEffect((): () => void => {
        const script: HTMLScriptElement = document.createElement('script');

        script.src = url;
        script.async = true;

        document.body.appendChild(script);

        script.addEventListener('load', (): void => {
            setLoaded(true);
        });

        return (): void => {
            document.body.removeChild(script);
        };
    }, []);

    return {
        loaded: loaded,
    };
}
